<template>
  <span>
    <b>{{ label }}</b>
    <br />
    {{formattedValue}}
  </span>
</template>

<script>
export default {
  props: {
    value: null,
    label: { type: String, default: '' },
    format: { type: String, default: 'text' },
    options: null
  },
  computed: {
    formattedValue: function () {
      switch (this.format) {
        case 'boolean': return this.value === true ? 'Sim' : 'Não'
        case 'cep': return this.$api.UI.Format.Cep(this.value)
        case 'phone': return this.$api.UI.Format.Telefone(this.value)
        case 'documento': return this.$api.UI.Format.DocumentoFederal(this.value)
        case 'datetime': return this.$api.UI.Format.DateTime(this.value)
        case 'date': return this.$api.UI.Format.Date(this.value)
        case 'time': return this.$api.UI.Format.Time(this.value)
        case 'time-seconds': return this.$api.UI.Format.Time(this.value, '00:00:00')
        case 'decimal': return this.$api.UI.Format.Decimal(this.value)
        case 'currency': return this.$api.UI.Format.Currency(this.value)
        case 'array': return this.getValue()
        default: return this.value
      }
    }
  },
  methods: {
    getValue (field, item) {
      var val = this.options.find(
        p =>
          p.value &&
            this.value &&
            p.value.toString().toUpperCase() ===
            this.value.toString().toUpperCase()
      )
      if (val) {
        return val.text
      } else {
        return ''
      }
    }
  }
}
</script>
